// extracted by mini-css-extract-plugin
export var deleteModal = "_gd-0";